export default __webpack_public_path__ + "static/media/img4.fc2e9ec4.PNG";